import React from "react";
import Config from "config";

const pagesLink = Config.pagesLink;

export const Breadcrumbs = React.memo((props) => {  // propertyDetail
  return (
    <>
      <section id="breadcrumbs">
        <a
          href={pagesLink.home}
          className="pxtm-click-linkClick"
          title="nav_หน้าหลัก"
          rel="noopener"
        >
          หน้าหลัก
        </a>
        <i className="ic-npa ic-npa-icon-arrow" />
        <a
          href={pagesLink.search}
          clas="pxtm-click-linkClick"
          title="nav_ค้นหาทรัพย์สิน"
          rel="noopener"
        >
          ค้นหาทรัพย์สิน
        </a>
        <i className="ic-npa ic-npa-icon-arrow" />
        <p className="current-page">{props.TitlePageName}</p>
      </section>
    </>
  );
}, areEqual);

function areEqual(prevProps, nextProps) {
  return prevProps.TitlePageName === nextProps.TitlePageName;
}
